import React from 'react';
import { IMAGES } from '../layout/theme';

const MainBanner = () => {
    return (
        <>
            <div className="banner-animate">
                <span className="stars">
                    <img src={IMAGES.Star1} alt="Stars" />
                </span>

                <span className="shooting-star shooting-star1">
                    <img src={IMAGES.ShootingStar} alt="Shooting Star1" />
                </span>
                <span className="shooting-star shooting-star2">
                    <img src={IMAGES.ShootingStar} alt="Shooting Star2" />
                </span>
                <span className="shooting-star shooting-star3">
                    <img src={IMAGES.ShootingStar} alt="Shooting Star3" />
                </span>
                <span className="shooting-star shooting-star4">
                    <img src={IMAGES.ShootingStar} alt="Shooting Star4" />
                </span>
                <span className="shooting-star shooting-star5">
                    <img src={IMAGES.ShootingStar} alt="Shooting Star5" />
                </span>
            </div>
            
        </>
    );
};

export default MainBanner;